import { ConfigService } from 'app/config/config.service';
import { tokenSchema } from 'app/agriculture/contexts/RequiredStartupProviders/TokenContext/tokenSchema';
import { z } from 'zod';
import { createAxiosInstance } from 'app/agriculture/queries/createAxiosInstance';
import { LOCAL_STORAGE_TOKEN_KEY } from './AuthComponent';
import axios from 'axios';

export async function getToken(): Promise<z.infer<typeof tokenSchema>> {
    const instance = createAxiosInstance({ baseURL: ConfigService.apiUrlRoot });
    const { data } = await instance.get<unknown>('auth/api-token-auth/');
    return tokenSchema.parse(data);
}

export async function setTokenDevMode() {
    if (!ConfigService.devMode) {
        throw new Error('Developer error: this should only be used for local development');
    }
    const instance = axios.create({
        baseURL: ConfigService.apiUrlRoot,
        withCredentials: true,
        withXSRFToken: true,
        xsrfHeaderName: 'X-CSRFToken',
        xsrfCookieName: 'csrftoken',
    });
    const { data } = await instance.get<unknown>('auth/api-token-auth/');
    const { token } = tokenSchema.parse(data);
    localStorage.setItem(LOCAL_STORAGE_TOKEN_KEY, token);
}
